/**
 * Chart theming from design tokens. Recharts takes color strings, so we resolve
 * the CSS custom properties to rgb() — charts then recolor automatically in dark
 * mode with the rest of the UI.
 */
export const chartColor = (token: string): string => `rgb(var(${token}))`;

export const chartTokens = {
  grid: chartColor('--nh-border'),
  axis: chartColor('--nh-fg-muted'),
  surface: chartColor('--nh-surface-raised'),
  fg: chartColor('--nh-fg'),
  border: chartColor('--nh-border'),
};

/**
 * Semantic series colours for security charts (fixed, not palette-ordered):
 * good/delivered flows are green, degraded/deferred amber, bad/blocked red,
 * informational blue, quarantine violet, terminal grey. Shared by the spam and
 * queue overviews so the same meaning always gets the same colour.
 */
export const semanticSeries = {
  good: '#2e7d52',
  degraded: '#b8791b',
  bad: '#c0392b',
  info: '#3f6ad8',
  quarantine: '#7c3aed',
  terminal: '#6b6a64',
} as const;

/** Ordered categorical palette for multi-series charts. */
export const chartPalette: string[] = [
  chartColor('--nh-brand'),
  chartColor('--nh-info'),
  chartColor('--nh-success'),
  chartColor('--nh-warning'),
  chartColor('--nh-danger'),
];

export const tooltipStyle = {
  background: chartTokens.surface,
  border: `1px solid ${chartTokens.border}`,
  borderRadius: 8,
  color: chartTokens.fg,
  fontSize: 12,
};

export const axisTick = { fill: chartTokens.axis, fontSize: 12 };
